// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { dateSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

const projectSchema = z.object({
  id: z.string(),
  key: z.string(),
  name: z.string(),
  startOn: dateSchema.nullable(),
  endOn: dateSchema.nullable(),
  isArchived: z.boolean(),
});

export type ProjectNode = z.infer<typeof projectSchema> & {
  projects: ProjectNode[];
};

const projectNodeSchema: z.ZodType<ProjectNode, z.ZodTypeDef, unknown> =
  projectSchema.extend({
    projects: z.lazy(() => projectNodeSchema.array()),
  });

const responseSchema = z
  .object({
    data: z.array(projectNodeSchema).transform((projects) => projects[0]),
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, project: data }));

export async function getProjectTree(key: string) {
  const path = `/v1/project/${key}/tree`;
  const response = await api.get(path);

  return parseResponse(responseSchema, response.data, {
    schemaName: 'ProjectTree',
    endpoint: path,
  });
}
